import React from 'react';
import axios from 'axios';
import moment from 'moment';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ambiente from '../../config/ambienteConfig';
import { exibirMensagem } from '../../redux/actions/mensagemAction';

class ProventosQuickAdd extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ativos: [],
            provento: {
                tipo: 'DIV',
                data: moment(),
                valor: '',
                ativo_id: '',
            },
            listaTipos: [
                { id: 'DIV', nome: 'Dividendos' },
                { id: 'JCP', nome: 'Juros sobre Capital' },
                { id: 'ALUG', nome: 'Aluguel' },
                { id: 'CUPOM', nome: 'Cupom' },
                { id: 'REND', nome: 'Rendimentos' },
            ],
        };
    }

    componentDidMount = async () => {
        try {
            const res = await axios.get(`${ambiente.dev.server}/ativos`);
            this.setState({ ativos: res.data });
            this.handleChangeProvAtt('ativo_id', res.data[0].id);
        } catch (err) {
            this.props.exibirMensagem('err', `Erro: ${err}`);
        }
    }

    handleChangeProvAtt(nome, valor) {
        const provento = Object.assign({}, this.state.provento);
        provento[nome] = valor;
        this.setState({ provento });
    }

    handleSave = async () => {
        try {
            await axios.post(`${ambiente.dev.server}/proventos`, this.state.provento);
            this.props.exibirMensagem('yay', `Provento inserido com sucesso!`);
        } catch (err) {
            this.props.exibirMensagem('err', `Erro: ${err}`);
        }
    }

    render() {
        const provento = this.state.provento;
        return (
            <div>
                <div className="row">
                    <div className="form-group col-6 col-md-4">
                        <select className="form-control" value={this.state.provento.ativo_id} onChange={evt => this.handleChangeProvAtt('ativo_id', evt.target.value)} autoFocus>
                            {this.state.ativos.map(item => <option key={item.id} value={item.id}>{item.nome}</option>)}
                        </select>
                    </div>
                    <div className="form-group col-6 col-md-4" data-toggle="buttons">
                        <select className="form-control" autoFocus value={provento.tipo} onChange={evt => this.handleChangeProvAtt('tipo', evt.target.value)}>
                            {this.state.listaTipos.map(item => <option key={item.id} value={item.id}>{item.nome}</option>)}
                        </select>
                    </div>
                    <div className="form-group col col-md-4">
                        <input type="date" className="form-control" value={provento.data.format('YYYY-MM-DD')}
                            onChange={evt => this.handleChangeProvAtt('data', moment(evt.target.value, 'YYYY-MM-DD'))} />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col">
                        <input type="number" step="0.01" className="form-control" value={provento.valor} placeholder="Valor"
                            onChange={evt => this.handleChangeProvAtt('valor', evt.target.value)} />
                    </div>
                </div>
                <button type="button" className="btn btn-primary btn-block" onClick={this.handleSave}>
                    Salvar
                </button>
            </div>
        );
    }
}

ProventosQuickAdd.propTypes = {
    exibirMensagem: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {};
}

function mapDispatchToProps(dispatch) {
    return {
        exibirMensagem: (tipo, texto) => dispatch(exibirMensagem(tipo, texto))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProventosQuickAdd);



// WEBPACK FOOTER //
// ./src/components/proventos/ProventosQuickAdd.js